/* src/app/components/video-quiz/video-quiz.component.scss */
:host {
  flex-direction: column;
}
.list-wrapper ul li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-right: 2px solid #1571b9;
  border-radius: 6px;
  font-weight: 600;
}
.list-wrapper ul li.active .list-active,
.list-wrapper ul li.active a {
  color: var(--listcolor) !important;
}
.list-wrapper ul li.active ::ng-deep .empty-img {
  background: #1571b9 !important;
  color: #fff !important;
}
.list-wrapper ul li:hover {
  background: var(--listbackgoundhover) !important;
}
.list-wrapper ul li:hover a {
  color: var(--listcolor) !important;
}
/*# sourceMappingURL=video-quiz.component.css.map */
